import React, { Component }          from 'react';

import { IndeterminateProgress } from '../common/IndeterminateProgress';
import icClose                   from '../../img/ic_close.svg'

import "./ForgotPassword.scss";
import Network from '../common/Network';

class ForgotPassword extends Component {

  constructor(props) {
    super(props);

    this.state            = {
      email: "",
      errorText: "",
      showErrorText: false,
      isSubmitting: false,
    }
  }

  onEmailChanged(event) {
    this.setState({email: event.target.value});
  }

  isEmailValid() {
    const matched = String(this.state.email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
    return matched !== null;
  }

  onLoginClick() {
    if (!this.state.email) {
      this.setState({showErrorText: true, errorText: "Please enter an email address"});
      this.animateLoginButton()
    } else if (!this.isEmailValid()) {
      this.setState({showErrorText: true, errorText: "The email address entered is invalid"});
      this.animateLoginButton()
    } else {
      this.setState({showErrorText: false, isSubmitting: true});
      console.log(`SUBMITTINg`)
      Network.post("/api/forgot-password-requests", {email: this.state.email})
        .then(() => {
          this.setState({isSubmitting: false, showSuccessDialog: true})
          setTimeout(() => {
            this.setState({showSuccessDialog: false})
            this.props.navigateTo("LOGIN")
          }, 2000)
        });
    }
  }

  animateLoginButton() {
    this.setState({animateLoginButton: true});
    setTimeout(() => this.setState({animateLoginButton: false}), 500);
  }

  render() {
    return (
      <div className={`forgot-password__container ${this.props.currentState === "FORGOT_PASSWORD" ? 'show' : ''}`}>
        <div className="mobile-header">
          <div className="mobile-header-title">Screen Test Admin</div>
        </div>
        <div className={`login-content ${this.state.isSubmitting ? 'blur' : ''}`}>
          <div className="title">Forgot Password</div>
          <div className="subtitle">Enter your email to send a reset password request</div>
          <div className="field">
            <div className="title">EMAIL</div>
            <input onChange={this.onEmailChanged.bind(this)} value={this.state.email} type="email"/>
          </div>
          <div className="field">
            <div onClick={this.onLoginClick.bind(this)} className={`action-button ${this.state.animateLoginButton ? 'incorrect-animate' : ''}`}>
              REQUEST RESET
            </div>
            <div className={`error-text ${this.state.showErrorText ? 'show' : ''}`}>{this.state.errorText}</div>
          </div>
        </div>
        <IndeterminateProgress show={this.state.isSubmitting} />
        <img onClick={() => this.props.navigateTo("LOGIN")} className="close-icon" src={icClose} />
        <div className={`dialog-container ${this.state.showSuccessDialog ? 'show' : ''}`}>
          <div className="dialog-content">
            Check your email for a link to reset your account password.
          </div>
        </div>
      </div>
    );
  }
}

export default ForgotPassword;